import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useLogError } from '@/composables/useLogError'
import { useHttpClient } from '@/composables/useHttpClient'
import { useCubeStore } from '@/stores/useCubeStore'
import { useMapStore } from '@/stores/useMapStore'
import { usePreprocessCube } from '@/composables/usePreprocessCube.ts'

export const useTourStore = defineStore('tour', () => {
  const { logError } = useLogError()
  const { backendApi } = useHttpClient()
  const { preprocessCube } = usePreprocessCube()

  // --- State ---

  const isTourComplete = ref(false)
  const isAfterTourComplete = ref(false)

  // --- Actions ---

  async function loadTourCubeList() {
    try {
      const cubeStore = useCubeStore()
      const mapStore = useMapStore()

      const result = await backendApi.get('/tour/getCubeListByCoordinates', {
        params: {
          ownCubeName: cubeStore.name,
          ...mapStore.coordinateConstraints,
        },
      })

      if (!result?.data?.bSuccess) {
        throw new Error('Tour cubes list request returned unsuccessful.')
      }

      const homeCoordinates = { lat: cubeStore.latitude, lng: cubeStore.longitude }
      const processedCubes = Object.keys(result.data.data).map((cubeName) =>
        preprocessCube(result.data.data[cubeName], homeCoordinates)
      )

      mapStore.setCubeList('tour', processedCubes)
      await mapStore.loadProducerPrices()
    } catch (err) {
      logError(`Requesting tour cubes list failed: ${err}`)
    }
  }

  return {
    // State
    isTourComplete,
    isAfterTourComplete,
    // Actions
    loadTourCubeList,
  }
})
